(function (angular) {
	angular.module('bizPartEngage').directive('bizActivityReminder', bizActivityReminder);
	angular.module('bizPartEngage').service('bizActivityReminderService', bizActivityReminderService);

	bizActivityReminderService.$inject = ["$http"];

	function bizActivityReminder() {
		return {
			restrict: 'AE',
			templateUrl: siteRootPath + 'FrontEnd/Core/Directives/Views/ActivityReminders.html',
			controllerAs: 'vm',
			controller: bizActivityReminderController
		};

		bizActivityReminderController.$inject = ["bizActivityReminderService", "bizPhraseLoaderService", "$filter", "$q", "$rootScope"];

		function bizActivityReminderController(bizActivityReminderService, bizPhraseLoaderService, $filter, $q, $rootScope) {
			var vm = this;

			vm.Initialize = Initialize;
			vm.GetPhrasePlaceholders = GetPhrasePlaceholders;

			bizPhraseLoaderService.LoadPart("activityreminder");

			function GetPhrasePlaceholders(reminder) {
				if (reminder.PhrasePlaceholders)
					return reminder.PhrasePlaceholders;

				var unitName = $rootScope.LoggedInUser.Units.length ? $rootScope.LoggedInUser.Units[0].Name : "";
				var parentUnitName = $rootScope.LoggedInUser.ParentUnits.length ? $rootScope.LoggedInUser.ParentUnits[0].Name : "";

				reminder.PhrasePlaceholders = {
					'#USER#': reminder.UserInfo.FirstName + ' ' + reminder.UserInfo.LastName,
					'#UNIT#': reminder.UserIdListUsedIndex == 0 ? unitName : parentUnitName,
					'#USERCOUNT#': reminder.UserIds.length - 1
				};

				return reminder.PhrasePlaceholders;
			}

			function Initialize() {
				if ($rootScope.LoggedInUser.Id <= 0)
					return;

				bizActivityReminderService.GetActivityReminders(1).then(InitializeCallback);

				function InitializeCallback(response) {
					var reminders = BizPartCoreHelpers.getResponseValue(response, []);

					for (var i = 0; i < reminders.length; i++) {
						if (!reminders[i].ImageUrl)
							continue

						vm.FirstImageUrl = reminders[i].ImageUrl;
						break;
					}

					vm.Reminders = reminders;
				}
			}

			vm.Initialize();
		}
	}

	function bizActivityReminderService($http) {
		var baseUrl = siteRootPath + 'api/ActivityReminder/'

		return {
			GetActivityReminders: GetActivityReminders,
			SetActivityReminderViewed: SetActivityReminderViewed
		}

		function GetActivityReminders(maxReminders) {
			return $http.get(baseUrl + 'GetActivityReminders', {
				params: {
					maxReminders: maxReminders
				}
			});
		}

		function SetActivityReminderViewed(reminder) {
			return $http.post(baseUrl + 'SetActivityReminderViewed', reminder);
		}
	}
})(window.angular);
